/* eslint-disable no-param-reassign */
export const EVENTS = {
  ALERT: 'ui.alert',
  START_LOADING: 'ui.startLoading',
  STOP_LOADING: 'ui.stopLoading',
  APP_MOUNTED: 'ui.appMounted',
};

const ui = {
  setup(namespace, root) {
    // setup shortcuts
    root.alert = (text = '', options = {}) => {
      root.emit(EVENTS.ALERT, text, options);
    };
    root.startLoading = (hideUI = false) => {
      root.emit(EVENTS.START_LOADING, hideUI);
    };
    root.stopLoading = () => {
      root.emit(EVENTS.STOP_LOADING);
    };
  },
};

export default ui;
